export let KeycloakConfig = Object.freeze(
    {
        "clientId": 'POMOD_BROWSER',
        //"clientId": 'Simeos',
        "realm": "AGT_SSO",
        "url": process.env.VUE_APP_GRUDU_URL //+ "/"
    });    